import React, { useCallback, useState } from "react";
import PageHeader from "../../Components/Common/PageHeader";
import { faPaypal } from "@fortawesome/free-brands-svg-icons";
import PaypalAccountsBlock from "../../Components/PaypalAccounts";
import PaypalTools from "../../Components/PaypalAccounts/PaypalTools";
import PaypalDisputes from "../../Components/PaypalAccounts/PaypalDisputes";
import PaypalJobsHistory from "../../Components/PaypalAccounts/PaypalJobsHistory";
import { PaypalJobsProvider } from "../../contexts/PaypalJobsContext";

const Gateways = () => {
  const [accountList, setAccountList] = useState([]);
  const handleAccountsChange = useCallback((list) => setAccountList(list), []);

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader
          title="PayPal"
          description="Quản lý cổng thanh toán PayPal và các công cụ export."
          icon={faPaypal}
        />

        <PaypalJobsProvider>
          <PaypalAccountsBlock onAccountsChange={handleAccountsChange} />
          <PaypalTools accountList={accountList} />
          <PaypalDisputes accountList={accountList} />
          <PaypalJobsHistory />
        </PaypalJobsProvider>
      </div>
    </main>
  );
};

export default Gateways;
